import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("menu.analytic.resources_requests"))),
      ]),
      _vm._t("default"),
      _c(
        VCard,
        { staticClass: "mt-2" },
        [
          _c(
            VCardActions,
            { staticClass: "pa-3 pb-1" },
            [
              _c(VSpacer),
              _c(
                VTooltip,
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              _vm._b(
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    outlined: "",
                                    fab: "",
                                    small: "",
                                    color: "primary",
                                  },
                                  on: { click: _vm.getResourcesRequests },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [_c(VIcon, [_vm._v("mdi-refresh")])],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("btns.refresh")))])]
              ),
              _c(
                VTooltip,
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            VBtn,
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    outlined: "",
                                    color: "primary",
                                    href: _vm.datastudio_url,
                                    target: "_blank",
                                  },
                                },
                                "v-btn",
                                attrs,
                                false
                              ),
                              on
                            ),
                            [
                              _c(VIcon, { attrs: { left: "" } }, [
                                _vm._v("mdi-view-dashboard"),
                              ]),
                              _vm._v("DASHBOARD"),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("frases.consumption_work_env"))),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(VDataTable, {
            key: _vm.key_table,
            staticClass: "text-center table-inca",
            attrs: {
              headers: _vm.headers,
              items: _vm.items,
              responsive: "",
              "hide-default-footer": "",
            },
            scopedSlots: _vm._u([
              {
                key: "item.requested_date",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("stringLongFormatDate")(item.requested_date)
                        )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "item.status",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c(
                      VChip,
                      {
                        attrs: {
                          color: _vm.statusColor(item),
                          "text-color": "white",
                          dense: "",
                          small: "",
                        },
                      },
                      [_vm._v(_vm._s(item.status))]
                    ),
                  ]
                },
              },
              {
                key: "item.actions",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    item.status === _vm.STATUS_PROCESSING
                      ? _c(VProgressCircular, {
                          attrs: { indeterminate: "", color: "primary" },
                        })
                      : _c(
                          VTooltip,
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "btn-icon-inca",
                                              attrs: { icon: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewDetail(item)
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c(VIcon, [_vm._v("icon-view")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("frases.view_request"))),
                            ]),
                          ]
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("dialogs-component", {
        ref: _vm.MODAL_RESPONSE_RESOURCE,
        attrs: {
          title:
            _vm.item.request === _vm.TYPE_UPDATE
              ? _vm.$t("titles.view_update_request")
              : _vm.$t("titles.view_create_request"),
          "show-buttons": "",
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("form-resource-response-component", {
                  ref: "viewRequestRef",
                  attrs: {
                    "request-obj": _vm.item,
                    "type-update": _vm.item.request === _vm.TYPE_UPDATE,
                  },
                  on: {
                    submit: _vm.onProccess,
                    cancel: function ($event) {
                      return _vm.$refs[_vm.MODAL_RESPONSE_RESOURCE].onClose()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "error" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.viewRequestRef.onReject($event)
                      },
                    },
                  },
                  [_c(VIcon, [_vm._v("icon-remove")]), _vm._v("REJECT")],
                  1
                ),
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$refs.viewRequestRef.onApprove($event)
                      },
                    },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v("APPROVE"),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }